import { RootState } from '../../store';

export const getAvailableExecutorsSeletor = (state: RootState) => state?.ticketReducer?.availableExecutors;
